var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-scope"},[_c('v-app',{attrs:{"id":"inspire"}},[_c('v-content',[_c('SnackBar'),_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }